export default __webpack_public_path__ + "static/media/flash22.2dc469e3.png";